<template>
  <cs-view single-view>
    <template #content>
      <div class="aha-portal-wrapper pa-2">
        <div id="aha-portal-container" ref="ahaPortalContainer"></div>
      </div>
    </template>
  </cs-view>
</template>

<script>
import { CSBase } from '@complispace/cs-design-system';

export default {
  extends: CSBase,

  data() {
    return {};
  },

  async mounted() {
    const { axiosInstance, eventPluginCommonAdapter, stbApiAdapter } = this.$app;
    const isVendorAuthScheme =
      !!this.$route.query['vendor-sid'] && !!this.$route.query['oauth-signature'];
    if (!isVendorAuthScheme) {
      await this.$store.dispatch('authorisation/validateAndSetUserTokenOrLogout', {
        query: this.$route.query,
        axiosInstance
      });
    }
    await this.$store.dispatch('common/initClientConfig', {
      queryParam: isVendorAuthScheme ? this.$route.query : {},
      eventPluginCommonAdapter,
      stbApiAdapter
    });

    if (!process.env.AHA_PORTAL_URL) {
      this.showWarningAlert('AHA! Ideas Portal is not supported.');
      return;
    }
    this.loadAhaPortal();
  },

  methods: {
    loadAhaPortal() {
      if (
        document.querySelector('script[src*="aha.io/assets/idea_portals/embedded/application.js"]')
      ) {
        return;
      }

      const script = document.createElement('script');
      script.async = true;
      script.src = 'https://secure.aha.io/assets/idea_portals/embedded/application.js';
      script.setAttribute('data-portal-url', process.env.AHA_PORTAL_URL);

      this.$refs.ahaPortalContainer.appendChild(script);
    }
  }
};
</script>
<style scoped>
.aha-portal-wrapper {
  overflow: hidden;
}

#aha-portal-container {
  width: 100%;
  height: 100%;
  overflow: hidden;
}
</style>
